import { useContext } from 'react';
import { SunOutlined, MoonOutlined } from '@ant-design/icons';
import { ThemeContext } from '@/shared/context/ThemeContext';
import '@/globalStyle.css';

const ThemeToggleBtn = () => {
  const { themeMode, toggleTheme } = useContext(ThemeContext);

  return (
    <div
      style={{
        cursor: 'pointer',
        color: 'var(--text-drawer)',
      }}
      onClick={toggleTheme}
    >
      {themeMode === 'light' ? (
        <SunOutlined style={{ fontSize: '24px' }} />
      ) : (
        <MoonOutlined style={{ fontSize: '24px' }} />
      )}
    </div>
  );
};

export default ThemeToggleBtn;
